import React from "react";
import ServiceDetailLayout from "../../components/service-detail-layout";
import diabetic from "../../assets/img/diabetic-foot-assessment.jpg";

/**
 * Diabetic Foot Care detail page component
 */
const DiabeticFootCareDetail = () => {
  return (
    <ServiceDetailLayout
      title="Diabetic Foot Care Assessment"
      description="Comprehensive diabetic foot assessment including circulation, sensation and foot structure evaluation. Specialist diabetes care with over 10 years NHS experience."
      image={diabetic}
      imageAlt="Diabetic Foot Assessment"
    >
      <h1 className="gs-u-mb+">Podiatry Care for Diabetic Patients</h1>
      <p className="text--large gs-u-mb++">
        Diabetes is a condition that disrupts the body's natural ability to make
        insulin, which in turn affects the levels of sugar in the blood. There
        are three main types of diabetes, with type 2 being the most prevalent.
      </p>

      <p className="gs-u-mb+">
        The signs of diabetes often appear slowly, and many individuals are
        unaware of their condition until it's too late. It's currently the most
        rapidly increasing non-infectious disease globally.
      </p>

      <p className="gs-u-mb+">
        The impact of diabetes on the body is widespread. It might come as a
        surprise, but the condition can also lead to issues with foot and lower
        limb health. Without proper preventive measures or treatment, the
        resulting complications can be severe. According to statistics, about 85
        individuals with diabetes each week experience the loss of a toe, foot,
        or even a leg due to diabetic foot complications.
      </p>

      <p className="gs-u-mb+">
        As a result, podiatry plays a vital role in the overall health
        management of individuals with diabetes.
      </p>

      <p className="gs-u-mb++">
        <strong>
          Anne Bloomer, our foot specialist at The Moffat Foot Clinic, is
          skilled and has a wealth of experience in offering preventive and
          specialised foot care. We invite you to reach out to us for a thorough
          evaluation and treatment strategy.
        </strong>
      </p>

      <h2 className="gs-u-mb+">Why is Foot Care Important in Diabetes?</h2>
      <p className="gs-u-mb+">
        Keeping your blood sugar levels within a healthy range is a crucial
        first step in controlling diabetes, and your healthcare team will help
        you with this. This can lower the chance of problems with your feet and
        lower limbs, especially when combined with podiatry treatment.
      </p>

      <p className="gs-u-mb++">
        Taking care of your feet regularly includes preventive actions, proper
        cleanliness, checking for symptoms of nerve damage or blood flow
        problems, and dealing with any problems right away they start. Our
        podiatrists offer advice and learning, do detailed evaluations, and
        carry out necessary treatments to help lower your risk of getting
        diabetes-related foot and lower limb problems.
      </p>

      <h2 className="gs-u-mb+">
        Possible Foot and Lower Limb Complications with Diabetes
      </h2>
      <p className="gs-u-mb+">
        Since individuals with diabetes have issues with insulin creation, their
        blood glucose levels may fluctuate beyond the usual limits, leading to a
        variety of indications and symptoms. For instance, inadequate blood
        flow, a frequent problem among diabetics, can hinder the healing of
        wounds, turning a small injury into a major issue.
      </p>

      <p className="gs-u-mb+">
        These elements increase the likelihood of infections and sores, and in
        extreme situations, could result in severe signs and require intensive
        care.
      </p>

      <p className="gs-u-mb+">
        Diabetes can lead to various problems in your feet or lower body parts,
        such as:
      </p>

      <h3 className="gs-u-mb+">Diabetes And Peripheral Neuropathy</h3>
      <p className="gs-u-mb++">
        High blood sugar levels can cause harm to nerves, a condition called
        neuropathy. This issue progresses gradually and intensifies as time goes
        on. Frequently, there are no signs because the feeling is diminished. As
        a result, many individuals cannot properly sense pain or discomfort in
        their feet, which raises the likelihood of getting hurt or developing
        sores.
      </p>

      <h3 className="gs-u-mb+">Diabetes and Charcot Foot Syndrome</h3>
      <p className="gs-u-mb++">
        Charcot Foot Syndrome is linked to diabetic peripheral neuropathy, which
        can lead to a severe complication resulting in diminished sensation in
        your feet. This situation could lead to an injury that you don't notice
        and might result in you continuing to use your feet despite the damage.
      </p>

      <h3 className="gs-u-mb+">Diabetes and Foot Ulcers</h3>
      <p className="gs-u-mb++">
        Foot ulcers are wounds on the feet that usually do not heal by
        themselves. They are often the most frequent problem that comes with
        diabetes that is not well managed. If you have diabetes, you might get a
        foot ulcer because of problems with blood sugar control, or because of
        nerve damage or poor blood flow in the legs and feet.
      </p>

      <h3 className="gs-u-mb+">Diabetes and Peripheral Arterial Disease</h3>
      <p className="gs-u-mb++">
        Arterial peripheral disease is a condition related to blood flow issues,
        resulting from the accumulation of cholesterol and fat in the artery
        walls. This buildup can cause a lack of adequate blood supply to the
        legs and feet's muscles. Consequently, it can cause discomfort in the
        muscles and heighten the chances of experiencing a heart attack or
        stroke.
      </p>

      <p className="gs-u-mb++">
        Minimise your chance of severe diabetes-related health issues through
        proper foot care.
      </p>

      <h2 className="gs-u-mb+">
        Early Detection and Diabetic Podiatry Care at The Moffat Foot Clinic
      </h2>
      <p className="gs-u-mb+">
        For individuals with diabetes, seeking podiatry services is likely to be
        an essential component of their health care and management strategy due
        to the potential complications affecting the lower extremities and feet.
        Regular appointments with a podiatrist could play a vital role in
        preserving your general health and quality of life.
      </p>

      <p className="gs-u-mb+">
        At The Moffat Foot Clinic, we offer consistent foot examinations and
        provide necessary care for diabetic foot health. Our goal is to
        evaluate, recognise, and address the wide range of problems associated
        with diabetes. We invite you to reach out to us to schedule a first
        meeting and get assistance with prevention, education, management, and
        treatment.
      </p>

      <p className="gs-u-mb+">
        We have had the privilege of providing high-quality and comprehensive
        care to our community in the privacy of their own homes. We are
        committed to assisting every one of our patients in improving their life
        quality.
      </p>

      <p className="gs-u-mb++">
        In managing diabetes, we are enthusiastic about aiding you as you
        navigate through this complex condition.
      </p>
    </ServiceDetailLayout>
  );
};

export default DiabeticFootCareDetail;
